import React from 'react'

export const StickyCloseIcon: React.FC<{ className?: string }> = ({
    className,
}) => {
    return (
        <svg
            className={className}
            width="16"
            height="16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13.4558 1.11713c.3549-.360802.9998-.301938 1.4405.13148.4406.43342.5102 1.07726.1553 1.43807L2.20038 15.7526c-.35488.3608-.99978.3019-1.440443-.1315-.440658-.4334-.510197-1.0772-.15532-1.438L13.4558 1.11713z"
                fill="#fff"
            />
            <path
                d="M15.1416 14.0573c.3605.3546.3012.9995-.1325 1.4405-.4338.441-1.0777.511-1.4382.1564L.514634 2.81248c-.360539-.35462-.301199-.99958.13254-1.44056C1.08091.930933 1.7248.860917 2.08534 1.21553L15.1416 14.0573z"
                fill="#fff"
            />
        </svg>
    )
}
